module.exports = __webpack_public_path__ + "media/images/hyperlink-28db32c201c3e7bfc279bc4971762341.svg";